import * as Sentry from '@sentry/react';

/** Los tres puntos del camino del botón donde se decide algo. */
export type AutolocateStep = 'position' | 'source' | 'resolution';

/**
 * Rastro del botón de autolocalizar PK.
 *
 * ── Por qué existe ─────────────────────────────────────────────────────────
 *
 * El botón falla de la peor manera posible: **sin error**. No lanza excepción,
 * no hay petición en rojo y el aviso que sale («no estás sobre ninguna vía, la
 * más cercana está a 1304 m») es indistinguible entre dos causas con arreglos
 * opuestos — un fix de GPS malo, o una malla incompleta. Sin saber qué
 * `accuracy` traía la posición y de qué fuente salió la respuesta, elegir
 * arreglo es adivinar.
 *
 * ── Por qué SIN gate de `import.meta.env.DEV` ──────────────────────────────
 *
 * 🔴 Porque si no, no se ve en campo, que es el único sitio donde ocurre. La
 * APK se compila con `cap:apk:debug:beta` → `build:beta` → `vite build --mode
 * beta`: **build de producción** dentro de un APK depurable. Ahí `DEV` es
 * `false`. Es lo que le pasa a la `traza` de `PauseSurveillanceRouteModal`, que
 * lleva ese gate y por tanto enmudece justo en la tablet para la que se
 * escribió.
 *
 * El coste es una línea por pulsación —no es un bucle de GPS— y el breadcrumb
 * viaja gratis con cualquier incidente que Sentry ya estuviera recogiendo.
 */
export function traceAutolocate(
  step: AutolocateStep,
  data?: Record<string, unknown>
): void {
  console.info(`[autolocate] ${step}`, data ?? {});
  Sentry.addBreadcrumb({
    category: 'autolocate',
    message: step,
    level: 'info',
    data: data ?? {},
  });
}

export default traceAutolocate;
